import http from '../utils/http';

const baseRoute = '/operacao/dashboard';

export default {
    buscarEmpresas() {
        return http.get({
            url: baseRoute + `/empresas`,
            lockScreen: true,
            lockMessage: 'Buscando empresas'
        });
    },

    buscarIndicadores(body) {
        return http.post({
            url: baseRoute + '/indicadores',
            data: body,
            lockScreen: false,
            lockMessage: 'Buscando indicadores'
        });
    }
};
